/***
 * https://gist.github.com/yrezgui/5653591
 */

function filesizeFilter() {
  let units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  return function (bytes, precision) {
    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return '?';
    }

    let unit = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }

    return bytes.toFixed(+precision) + ' ' + units[unit];
  };
}

export default filesizeFilter;



// WEBPACK FOOTER //
// ./client/app/shared/filters/filesize.filter.js